<template>

  <cw_query_input ref="queryInput"  :inputProperty="inputProperty" :propertyObject="propertyObject"
                  :label="label">
      <div  class="query_input_header" >
          <slot name="header"></slot>
      </div>
      <div  class="query_input_container">
          <slot name="container"></slot>
      </div>
      <div  class="query_input_footer" >
           <slot name="footer"></slot>
      </div>
  </cw_query_input>
    
</template>

<script>
import cw_query_input from 'components/query/cw_query_input.vue'
export default {
    components:{
        cw_query_input
    },
    props:{
        label:{
            type:String
        },
        inputProperty:{
           type:String
        },
        propertyObject:{
            type:Object
        },
    },
    methods:{
        closeQueryWindow(){
            this.$refs.queryInput.closeQueryWindow();
        },
        openQueryWindow(){
            this.$refs.queryInput.openQueryWindow();
        }
    }
}
</script>

<style scoped>

</style>